import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import { requireModels } from '@/utils/require';

export default function (Vue) {
  const database = new VuexORM.Database();

  requireModels().forEach((pair) => {
    const componentConfig = pair[1];
    database.register(componentConfig);
  });

  VuexORM.use(VuexORMAxios, {
    axios: Vue.axios,
  });

  return VuexORM.install(database);
}
